import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Palette, EVEntry } from '@uswitch/ev-core/react';
import { createElement as _createElement } from "theme-ui";
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export default (function (_ref) {
  var children = _ref.children,
      entries = _ref.entries,
      options = _ref.options;

  var styling = _objectSpread({
    textAlign: 'center',
    display: 'flex',
    flexDirection: ['column', 'row'],
    justifyContent: 'space-evenly',
    alignItems: 'center',
    py: 'xs',
    margin: 'auto',
    variant: 'layout.flex-grid.container',
    '> *': {
      my: ['xs', 'inherit']
    },
    '[class*="palette"]': {
      width: 'auto',
      '*': {
        my: [0, 'inherit']
      }
    },
    img: {
      width: 'auto'
    }
  }, options);

  var childrenArray = entries ? entries.map(function (entity, i) {
    return _createElement(EVEntry, _objectSpread(_objectSpread({}, entity), {}, {
      key: i
    }));
  }) : children;
  return _jsx(Palette, {
    as: "div",
    px: {
      backgroundColor: 'backgroundColor'
    },
    children: _jsx("div", {
      sx: styling,
      children: childrenArray.map(function (child, key) {
        return _jsx("div", {
          children: _jsx(child.type, _objectSpread({}, child.props))
        }, key);
      }, this)
    })
  });
});
//# sourceMappingURL=collection-inline.js.map